export default "__VITE_ASSET__C0ba89S1__"